import { useTranslation } from 'react-i18next';
import {
  Answer,
  type CreateDataRequestDto,
  LegalBasisPersonalDataReason,
} from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

export const PersonalDataLegalBasisReason = () => {
  // Namelijk
  const { t } = useTranslation('dataRequest');
  const { FormText, FormRadio, ConditionalField } =
    typedFormFields<CreateDataRequestDto>();

  const legalBasisPersonalDataReasonOptions = [
    {
      label: t(
        `legal_basis_personal_data_reason.${LegalBasisPersonalDataReason.SignedCustomerMandate}`,
      ),
      value: LegalBasisPersonalDataReason.SignedCustomerMandate,
    },
    {
      label: t(
        `legal_basis_personal_data_reason.${LegalBasisPersonalDataReason.LegalObligation}`,
      ),
      value: LegalBasisPersonalDataReason.LegalObligation,
    },
    {
      label: t(
        `legal_basis_personal_data_reason.${LegalBasisPersonalDataReason.PublicTask}`,
      ),
      value: LegalBasisPersonalDataReason.PublicTask,
    },
    {
      label: t(
        `legal_basis_personal_data_reason.${LegalBasisPersonalDataReason.LegitimateInterest}`,
      ),
      value: LegalBasisPersonalDataReason.LegitimateInterest,
    },
    {
      label: t(
        `legal_basis_personal_data_reason.${LegalBasisPersonalDataReason.Other}`,
      ),
      renderInput: (
        <ConditionalField
          field="legalBasisPersonalDataReasonNote"
          condition={(formValue) =>
            formValue('legalBasisPersonalDataReason') ===
            LegalBasisPersonalDataReason.Other
          }
        >
          <FormText
            aria-label={t('other_note')}
            name={'legalBasisPersonalDataReasonNote'}
            fullWidth
            showWordCount
            rules={{ maxLength: 200, minLength: 2, required: true }}
          />
        </ConditionalField>
      ),
      value: LegalBasisPersonalDataReason.Other,
    },
  ];

  return (
    <ConditionalField
      field="legalBasisPersonalDataReason"
      condition={(formValue) =>
        formValue('legalBasisPersonalData') === Answer.Yes
      }
    >
      <FormRadio
        label={t('legal_basis_personal_data_reason')}
        name="legalBasisPersonalDataReason"
        options={legalBasisPersonalDataReasonOptions}
        rules={{ required: true }}
      />
    </ConditionalField>
  );
};
